<template>
  <b-modal
    id="cart_info_dlg"
    ref="cart_info_dlg"
    title="Thêm vào giỏ hàng thành công"
    hide-footer>
    <div class="cart">
      <div class="cart-left">
        <img
          :src="base_url + vatpham.image"
          width="100%">
      </div>
      <div class="cart-right">
        <div class="cart-body">
          <div class="cart-name">{{ vatpham.name }}</div>
          <div class="sale-price">{{ vatpham.price_sale }} đ</div>
        </div>
      </div>
    </div>
    <div>
      <router-link
        :to="'/cart'"
        class="btn btn-order btn-pri">
        Xem giỏ hàng
      </router-link>
    </div>
  </b-modal>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'

  export default {
    name: "PtDialog",

    // eslint-disable-next-line vue/require-prop-types
    props: ["vatpham"],

    data() {
      return {
        base_url: ApiConfig.base_url
      }
    }
  }
</script>

<style scoped>
  .cart {
    width: 100%;
    display: flex;
  }

  .cart .cart-left {
    flex-basis: 40%;
    width: 40%;
  }

  .cart .cart-right {
    flex-basis: 60%;
    position: absolute;
    right: 0;
    width: 60%;
  }

  .cart-right .cart-body {
    margin-left: 10px;
    position: relative;
    padding: 9px;
  }

  .cart-right .cart-body .cart-name {
    font-size: 16px;
    font-weight: bold;
    padding: 4px;
  }

  .cart-right .cart-body .sale-price {
    font-size: 14px;
    font-weight: bold;
    color: red;
    padding: 4px;
  }
  .btn-pri {
    background: #4189EB;
    color: #fff;
    border-radius: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PtDialog.vue